export default __webpack_public_path__ + "static/media/MW.bb24e3cd.svg";